import { InnerBlocks } from '@wordpress/block-editor';

const CustomAppender = () => (
  <div className="custom-appender-wrapper">
    <InnerBlocks.ButtonBlockAppender />
  </div>
);

export default CustomAppender;
